import { READ, FORM_UPDATE } from '../../../../store/type'
import { SABRE_REMARK } from "./type";
export const mutations = {
    [SABRE_REMARK + READ]: (state, { data, fieldInfoList }) => {
        state.data = data
        state.fieldInfoList = fieldInfoList
    }
};